import { PricePlanSwitcher } from 'common/components/entities/price-element/price-element-period/price-plan-switcher'
import { PageLocaleEnum } from 'common/enums/PageLocaleEnum'
import { TFunction } from 'i18next'
import React, { useMemo } from 'react'
import { PricePlanPeriodType } from '../price-element-interface'
import { PriceElementPeriodTitle, PriceElementPeriodUi } from './ui'

interface CommonPriceElementPeriodProps {
  activeBtn: PricePlanPeriodType
  onClick: (value: PricePlanPeriodType) => void
  locale: PageLocaleEnum
  t: TFunction
  isLoading: boolean
}

export const CommonPriceElementPeriod = ({
  activeBtn,
  onClick,
  isLoading,
  t,
}: CommonPriceElementPeriodProps) => {
  const isAnnualActive = useMemo(() => activeBtn === 'annually', [activeBtn])

  const togglePeriod = (): void => {
    if (isLoading) {
      return
    }

    if (activeBtn === 'monthly') {
      onClick('annually')
    } else {
      onClick('monthly')
    }
  }

  return (
    <PriceElementPeriodUi>
      <PriceElementPeriodTitle>
        {t('components.price_element.title')}
      </PriceElementPeriodTitle>
      <PricePlanSwitcher isChecked={isAnnualActive} onClick={togglePeriod} />
    </PriceElementPeriodUi>
  )
}
